import Head from 'next/head';

import { CourseListItem, createCourseListStructuredData } from '../utils/create-course-list-structured-data';

export function CourseListStructuredData({ items }: { items: CourseListItem[] }) {
  const hasLinkableCourses = items.some((item) => item.slug && item.title);
  if (!hasLinkableCourses) return null;
  const structuredData = {
    '@context': 'https://schema.org',
    ...createCourseListStructuredData(items),
  };
  return (
    <Head>
      <script
        key='structured-data-course-list'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        type='application/ld+json'
      />
    </Head>
  );
}
